import { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "./index";

const onRequest = async (
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  let token = localStorage.getItem("accessToken");
  let userType = localStorage.getItem("userType");
  const decodedToken: any = token ? jwtDecode(token) : null;
  const currentTime = Date.now() / 1000;
  if (
    decodedToken &&
    decodedToken.exp < currentTime &&
    config?.url !== "auth/refresh-token"
  ) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      const response = await axiosInstance.post(`auth/refresh-token`, {
        refreshToken: refreshToken,
      });
      localStorage.setItem("accessToken", response.data.result.token);
      localStorage.setItem("refreshToken", response.data.result.refreshToken);
      token = response.data.result.access_token;
    }
  }
  if (token) {
    return {
      ...config,
      headers: {
        ...config.headers,
        'ngrok-skip-browser-warning': true,
        Authorization: `Bearer ${token}`,
        userType: userType,
      },
    };
  }
        
  return config;
};

const onResponseError = async (error: any): Promise<AxiosError> => {
  console.error(`[response error] [${JSON.stringify(error)}]`);
  // @ts-ignore
  if (error.response?.status === 400) {
    const originalConfig: any = error.config;
    if (originalConfig?.url === "auth/refresh-token") {
      console.log("Error while fetching new access token");
      localStorage.clear();
      window.location.href = "/login";
    }
    if (
      originalConfig?.url !== "auth/login" &&
      originalConfig?.url !== "auth/refresh-token" &&
      error.response
    ) {
      // @ts-ignore
      if (
        (error?.response?.data?.status === 401 ||
          error?.response?.data?.status === 403) &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          console.error('No refresh token available');
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(error);
        }
        try {
          const rs = await axiosInstance.post("auth/refresh-token", {
            refreshToken: refreshToken,
          });
          const { access_token } = rs.data?.result || {};
          if (access_token) localStorage.setItem("accessToken", access_token);
          return axiosInstance(originalConfig);
        } catch (err: any) {
          console.log(err);
          localStorage.clear();
          window.location.href = "/login";
        }
      }
    }
  }
  return Promise.reject(error);
};

export const setupInterceptorsTo = (
  axiosInstance: AxiosInstance): AxiosInstance => {
  // @ts-ignore
  axiosInstance.interceptors.request.use(onRequest);
  axiosInstance.interceptors.response.use(undefined, onResponseError);
  return axiosInstance;
};
